// ข้อมูลจากไฟล์ Excel
export const courtList = {
  COURT_1: [1, "ศาลแพ่ง"],
  COURT_2: [2, "ศาลอาญา"],
  COURT_3: [3, "ศาลแพ่งธนบุรี"],
  COURT_4: [4, "ศาลอาญาธนบุรี"],
  COURT_5: [5, "ศาลแรงงานกลาง"],
  COURT_6: [6, "ศาลภาษีอากรกลาง"],
  COURT_7: [7, "ศาลแพ่งกรุงเทพใต้"],
  COURT_8: [8, "ศาลอาญากรุงเทพใต้"],
  COURT_9: [9, "ศาลเยาวชนและครอบครัวกลาง"],
  COURT_10: [10, "ศาลทรัพย์สินทางปัญญาและการค้าระหว่างประเทศกลาง"],
  COURT_11: [11, "ศาลล้มละลายกลาง"],
  COURT_13: [13, "ศาลจังหวัดชัยนาท"],
  COURT_14: [14, "ศาลแขวงดุสิต"],
  COURT_15: [15, "ศาลจังหวัดตลิ่งชัน"],
  COURT_16: [16, "ศาลจังหวัดธัญบุรี"],
  COURT_17: [17, "ศาลแขวงธนบุรี"],
  COURT_18: [18, "ศาลจังหวัดนนทบุรี"],
  COURT_19: [19, "ศาลแขวงนนทบุรี"],
  COURT_20: [20, "ศาลเยาวชนและครอบครัวจังหวัดนนทบุรี"],
  COURT_21: [21, "ศาลจังหวัดปทุมธานี"],
  COURT_22: [22, "ศาลเยาวชนและครอบครัวจังหวัดปทุมธานี"],
  COURT_23: [23, "ศาลแขวงปทุมวัน"],
  COURT_24: [24, "ศาลจังหวัดพระโขนง"],
  COURT_25: [25, "ศาลแขวงพระนครใต้"],
  COURT_26: [26, "ศาลแขวงพระนครเหนือ"],
  COURT_27: [27, "ศาลจังหวัดพระนครศรีอยุธยา"],
  COURT_28: [28, "ศาลเยาวชนและครอบครัวจังหวัดพระนครศรีอยุธยา"],
  COURT_29: [29, "ศาลแขวงพระนครศรีอยุธยา"],
  COURT_30: [30, "ศาลจังหวัดมีนบุรี"],
  COURT_31: [31, "ศาลจังหวัดลพบุรี"],
  COURT_32: [32, "ศาลแขวงลพบุรี"],
  COURT_33: [33, "ศาลจังหวัดสิงห์บุรี"],
  COURT_34: [34, "ศาลเยาวชนและครอบครัวจังหวัดสิงห์บุรี"],
  COURT_35: [35, "ศาลจังหวัดสระบุรี"],
  COURT_36: [36, "ศาลเยาวชนและครอบครัวจังหวัดสระบุรี"],
  COURT_37: [37, "ศาลจังหวัดสมุทรปราการ"],
  COURT_38: [38, "ศาลแขวงสมุทรปราการ"],
  COURT_39: [39, "ศาลเยาวชนและครอบครัวจังหวัดสมุทรปราการ"],
  COURT_40: [40, "ศาลจังหวัดอ่างทอง"],
  COURT_42: [42, "ศาลจังหวัดกบินทร์บุรี"],
  COURT_43: [43, "ศาลจังหวัดจันทบุรี"],
  COURT_44: [44, "ศาลเยาวชนและครอบครัวจังหวัดจันทบุรี"],
  COURT_45: [45, "ศาลจังหวัดฉะเชิงเทรา"],
  COURT_46: [46, "ศาลจังหวัดชลบุรี"],
  COURT_47: [47, "ศาลแขวงชลบุรี"],
  COURT_48: [48, "ศาลเยาวชนและครอบครัวจังหวัดชลบุรี"],
  COURT_49: [49, "ศาลจังหวัดตราด"],
  COURT_50: [50, "ศาลจังหวัดนครนายก"],
  COURT_51: [51, "ศาลจังหวัดปราจีนบุรี"],
  COURT_52: [52, "ศาลจังหวัดพัทยา"],
  COURT_53: [53, "ศาลจังหวัดระยอง"],
  COURT_54: [54, "ศาลเยาวชนและครอบครัวจังหวัดระยอง"],
  COURT_55: [55, "ศาลจังหวัดสระแก้ว"],
  COURT_57: [57, "ศาลจังหวัดกันทรลักษ์"],
  COURT_58: [58, "ศาลจังหวัดชัยภูมิ"],
  COURT_59: [59, "ศาลจังหวัดนครราชสีมา"],
  COURT_60: [60, "ศาลแขวงนครราชสีมา"],
  COURT_61: [61, "ศาลเยาวชนและครอบครัวจังหวัดนครราชสีมา"],
  COURT_62: [62, "ศาลจังหวัดบุรีรัมย์"],
  COURT_63: [63, "ศาลเยาวชนและครอบครัวจังหวัดบุรีรัมย์"],
  COURT_64: [64, "ศาลจังหวัดนางรอง"],
  COURT_65: [65, "ศาลจังหวัดบัวใหญ่"],
  COURT_66: [66, "ศาลจังหวัดภูเขียว"],
  COURT_67: [67, "ศาลจังหวัดยโสธร"],
  COURT_68: [68, "ศาลจังหวัดรัตนบุรี"],
  COURT_69: [69, "ศาลจังหวัดศรีสะเกษ"],
  COURT_70: [70, "ศาลจังหวัดสีคิ้ว"],
  COURT_71: [71, "ศาลจังหวัดสีคิ้ว (ปากช่อง)"],
  COURT_72: [72, "ศาลจังหวัดสุรินทร์"],
  COURT_73: [73, "ศาลแขวงสุรินทร์"],
  COURT_74: [74, "ศาลจังหวัดอุบลราชธานี"],
  COURT_75: [75, "ศาลแขวงอุบลราชธานี"],
  COURT_76: [76, "ศาลเยาวชนและครอบครัวจังหวัดอุบลราชธานี"],
  COURT_77: [77, "ศาลจังหวัดเดชอุดม"],
  COURT_78: [78, "ศาลจังหวัดอำนาจเจริญ"],
  COURT_79: [79, "ศาลเยาวชนและครอบครัวจังหวัดอำนาจเจริญ"],
  COURT_81: [81, "ศาลจังหวัดกาฬสินธุ์"],
  COURT_82: [82, "ศาลจังหวัดขอนแก่น"],
  COURT_83: [83, "ศาลแขวงขอนแก่น"],
  COURT_84: [84, "ศาลเยาวชนและครอบครัวจังหวัดขอนแก่น"],
  COURT_85: [85, "ศาลจังหวัดนครพนม"],
  COURT_86: [86, "ศาลเยาวชนและครอบครัวจังหวัดนครพนม"],
  COURT_87: [87, "ศาลจังหวัดบึงกาฬ"],
  COURT_88: [88, "ศาลจังหวัดพล"],
  COURT_89: [89, "ศาลจังหวัดมหาสารคาม"],
  COURT_90: [90, "ศาลจังหวัดมุกดาหาร"],
  COURT_91: [91, "ศาลจังหวัดร้อยเอ็ด"],
  COURT_92: [92, "ศาลเยาวชนและครอบครัวจังหวัดร้อยเอ็ด"],
  COURT_93: [93, "ศาลจังหวัดเลย"],
  COURT_94: [94, "ศาลจังหวัดสกลนคร"],
  COURT_95: [95, "ศาลจังหวัดสว่างแดนดิน"],
  COURT_96: [96, "ศาลจังหวัดหนองคาย"],
  COURT_97: [97, "ศาลจังหวัดหนองบัวลำภู"],
  COURT_98: [98, "ศาลจังหวัดอุดรธานี"],
  COURT_99: [99, "ศาลแขวงอุดรธานี"],
  COURT_100: [100, "ศาลเยาวชนและครอบครัวจังหวัดอุดรธานี"],
  COURT_102: [102, "ศาลจังหวัดเชียงใหม่"],
  COURT_103: [103, "ศาลแขวงเชียงใหม่"],
  COURT_104: [104, "ศาลเยาวชนและครอบครัวจังหวัดเชียงใหม่"],
  COURT_105: [105, "ศาลจังหวัดเชียงราย"],
  COURT_106: [106, "ศาลจังหวัดน่าน"],
  COURT_107: [107, "ศาลจังหวัดฝาง"],
  COURT_108: [108, "ศาลจังหวัดพะเยา"],
  COURT_109: [109, "ศาลจังหวัดแพร่"],
  COURT_110: [110, "ศาลจังหวัดลำปาง"],
  COURT_111: [111, "ศาลแขวงลำปาง"],
  COURT_112: [112, "ศาลเยาวชนและครอบครัวจังหวัดลำปาง"],
  COURT_113: [113, "ศาลจังหวัดลำพูน"],
  COURT_114: [114, "ศาลจังหวัดแม่สะเรียง"],
  COURT_115: [115, "ศาลจังหวัดแม่ฮ่องสอน"],
  COURT_117: [117, "ศาลจังหวัดกำแพงเพชร"],
  COURT_118: [118, "ศาลจังหวัดตาก"],
  COURT_119: [119, "ศาลจังหวัดนครสวรรค์"],
  COURT_120: [120, "ศาลแขวงนครสวรรค์"],
  COURT_121: [121, "ศาลเยาวชนและครอบครัวจังหวัดนครสวรรค์"],
  COURT_122: [122, "ศาลจังหวัดพิษณุโลก"],
  COURT_123: [123, "ศาลแขวงพิษณุโลก"],
  COURT_124: [124, "ศาลเยาวชนและครอบครัวจังหวัดพิษณุโลก"],
  COURT_125: [125, "ศาลจังหวัดพิจิตร"],
  COURT_126: [126, "ศาลจังหวัดเพชรบูรณ์"],
  COURT_127: [127, "ศาลจังหวัดแม่สอด"],
  COURT_128: [128, "ศาลจังหวัดสวรรคโลก"],
  COURT_129: [129, "ศาลจังหวัดสุโขทัย"],
  COURT_130: [130, "ศาลจังหวัดหล่มสัก"],
  COURT_131: [131, "ศาลจังหวัดอุตรดิตถ์"],
  COURT_132: [132, "ศาลจังหวัดอุทัยธานี"],
  COURT_134: [134, "ศาลจังหวัดกาญจนบุรี"],
  COURT_135: [135, "ศาลจังหวัดทองผาภูมิ"],
  COURT_136: [136, "ศาลเยาวชนและครอบครัวจังหวัดกาญจนบุรี"],
  COURT_137: [137, "ศาลจังหวัดนครปฐม"],
  COURT_138: [138, "ศาลแขวงนครปฐม"],
  COURT_139: [139, "ศาลเยาวชนและครอบครัวจังหวัดนครปฐม"],
  COURT_140: [140, "ศาลจังหวัดประจวบคีรีขันธ์"],
  COURT_141: [141, "ศาลจังหวัดเพชรบุรี"],
  COURT_142: [142, "ศาลจังหวัดราชบุรี"],
  COURT_143: [143, "ศาลแขวงราชบุรี"],
  COURT_144: [144, "ศาลเยาวชนและครอบครัวจังหวัดราชบุรี"],
  COURT_145: [145, "ศาลจังหวัดสมุทรสาคร"],
  COURT_146: [146, "ศาลจังหวัดสมุทรสงคราม"],
  COURT_147: [147, "ศาลจังหวัดสุพรรณบุรี"],
  COURT_148: [148, "ศาลแขวงสุพรรณบุรี"],
  COURT_149: [149, "ศาลเยาวชนและครอบครัวจังหวัดสุพรรณบุรี"],
  COURT_151: [151, "ศาลจังหวัดกระบี่"],
  COURT_152: [152, "ศาลจังหวัดชุมพร"],
  COURT_153: [153, "ศาลจังหวัดไชยา"],
  COURT_154: [154, "ศาลจังหวัดตะกั่วป่า"],
  COURT_155: [155, "ศาลจังหวัดทุ่งสง"],
  COURT_156: [156, "ศาลจังหวัดนครศรีธรรมราช"],
  COURT_157: [157, "ศาลแขวงนครศรีธรรมราช"],
  COURT_158: [158, "ศาลเยาวชนและครอบครัวจังหวัดนครศรีธรรมราช"],
  COURT_159: [159, "ศาลจังหวัดปากพนัง"],
  COURT_160: [160, "ศาลจังหวัดพังงา"],
  COURT_161: [161, "ศาลจังหวัดภูเก็ต"],
  COURT_162: [162, "ศาลเยาวชนและครอบครัวจังหวัดภูเก็ต"],
  COURT_163: [163, "ศาลจังหวัดระนอง"],
  COURT_164: [164, "ศาลจังหวัดสุราษฎร์ธานี"],
  COURT_165: [165, "ศาลแขวงสุราษฎร์ธานี"],
  COURT_166: [166, "ศาลเยาวชนและครอบครัวจังหวัดสุราษฎร์ธานี"],
  COURT_167: [167, "ศาลจังหวัดหลังสวน"],
  COURT_169: [169, "ศาลจังหวัดตรัง"],
  COURT_170: [170, "ศาลเยาวชนและครอบครัวจังหวัดตรัง"],
  COURT_171: [171, "ศาลจังหวัดนราธิวาส"],
  COURT_172: [172, "ศาลเยาวชนและครอบครัวจังหวัดนราธิวาส"],
  COURT_173: [173, "ศาลจังหวัดเบตง"],
  COURT_174: [174, "ศาลจังหวัดปัตตานี"],
  COURT_175: [175, "ศาลเยาวชนและครอบครัวจังหวัดปัตตานี"],
  COURT_176: [176, "ศาลจังหวัดพัทลุง"],
  COURT_177: [177, "ศาลจังหวัดยะลา"],
  COURT_178: [178, "ศาลจังหวัดสงขลา"],
  COURT_179: [179, "ศาลแขวงสงขลา"],
  COURT_180: [180, "ศาลเยาวชนและครอบครัวจังหวัดสงขลา"],
  COURT_181: [181, "ศาลจังหวัดสตูล"],
  COURT_182: [182, "ศาลเยาวชนและครอบครัวจังหวัดสตูล"],
  COURT_183: [183, "ศาลฎีกา"],
  COURT_184: [184, "ศาลอุทธรณ์"],
  COURT_185: [185, "ศาลอุทธรณ์ภาค 1"],
  COURT_186: [186, "ศาลอุทธรณ์ภาค 2"],
  COURT_187: [187, "ศาลอุทธรณ์ภาค 3"],
  COURT_188: [188, "ศาลอุทธรณ์ภาค 4"],
  COURT_189: [189, "ศาลอุทธรณ์ภาค 5"],
  COURT_190: [190, "ศาลอุทธรณ์ภาค 6"],
  COURT_191: [191, "ศาลอุทธรณ์ภาค 7"],
  COURT_192: [192, "ศาลอุทธรณ์ภาค 8"],
  COURT_193: [193, "ศาลอุทธรณ์ภาค 9"],
  COURT_194: [194, "ศาลเยาวชนและครอบครัวจังหวัดลำพูน"],
  COURT_195: [195, "ศาลจังหวัดเทิง"],
  COURT_196: [196, "ศาลจังหวัดเกาะสมุย"],
  COURT_197: [197, "ศาลจังหวัดนาทวี"],
  COURT_198: [198, "ศาลจังหวัดชัยบาดาล"],
  COURT_199: [199, "ศาลจังหวัดน่าน สาขาปัว"],
  COURT_200: [200, "ศาลจังหวัดแม่ฮ่องสอน สาขาปาย"],
  COURT_202: [202, "ศาลเยาวชนและครอบครัวจังหวัดอ่างทอง"],
  COURT_203: [203, "ศาลเยาวชนและครอบครัวจังหวัดฉะเชิงเทรา"],
  COURT_204: [204, "ศาลเยาวชนและครอบครัวจังหวัดศรีสะเกษ"],
  COURT_205: [205, "ศาลเยาวชนและครอบครัวจังหวัดเพชรบูรณ์"],
  COURT_206: [206, "ศาลเยาวชนและครอบครัวจังหวัดสุโขทัย"],
  COURT_207: [207, "ศาลเยาวชนและครอบครัวจังหวัดเพชรบุรี"],
  COURT_208: [208, "ศาลเยาวชนและครอบครัวจังหวัดสมุทรสาคร"],
  COURT_210: [210, "ศาลจังหวัดเวียงสระ"],
  COURT_211: [211, "ศาลจังหวัดหัวหิน"],
  COURT_213: [213, "ศาลเยาวชนและครอบครัวจังหวัดมุกดาหาร"],
  COURT_214: [214, "ศาลจังหวัดวิเชียรบุรี"],
  COURT_215: [215, "ศาลจังหวัดพิมาย"],
  COURT_216: [216, "ศาลแขวงพัทยา"],
  COURT_217: [217, "ศาลแขวงสระบุรี"],
  COURT_218: [218, "ศาลแขวงเวียงป่าเป้า"],
  COURT_219: [219, "ศาลแขวงทุ่งสง"],
  COURT_220: [220, "ศาลจังหวัดฮอด"],
  COURT_221: [221, "ศาลแขวงดอนเมือง"],
  COURT_224: [224, "ศาลแพ่งมีนบุรีและศาลอาญามีนบุรีแผนกคดีเยาวชนและครอบครัว"],
  COURT_225: [225, "ศาลเยาวชนและครอบครัวจังหวัดกระบี่"],
  COURT_226: [226, "ศาลเยาวชนและครอบครัวจังหวัดกาฬสินธุ์"],
  COURT_227: [227, "ศาลเยาวชนและครอบครัวจังหวัดกำแพงเพชร"],
  COURT_228: [228, "ศาลเยาวชนและครอบครัวจังหวัดชัยนาท"],
  COURT_229: [229, "ศาลเยาวชนและครอบครัวจังหวัดชัยภูมิ"],
  COURT_230: [230, "ศาลเยาวชนและครอบครัวจังหวัดชุมพร"],
  COURT_231: [231, "ศาลเยาวชนและครอบครัวจังหวัดเชียงราย"],
  COURT_232: [232, "ศาลเยาวชนและครอบครัวจังหวัดตราด"],
  COURT_233: [233, "ศาลเยาวชนและครอบครัวจังหวัดตาก"],
  COURT_234: [234, "ศาลเยาวชนและครอบครัวจังหวัดนครนายก"],
  COURT_235: [235, "ศาลเยาวชนและครอบครัวจังหวัดน่าน"],
  COURT_236: [236, "ศาลเยาวชนและครอบครัวจังหวัดประจวบคีรีขันธ์"],
  COURT_237: [237, "ศาลเยาวชนและครอบครัวจังหวัดปราจีนบุรี"],
  COURT_238: [238, "ศาลเยาวชนและครอบครัวจังหวัดพะเยา"],
  COURT_239: [239, "ศาลเยาวชนและครอบครัวจังหวัดพังงา"],
  COURT_240: [240, "ศาลเยาวชนและครอบครัวจังหวัดพัทลุง"],
  COURT_241: [241, "ศาลเยาวชนและครอบครัวจังหวัดพิจิตร"],
  COURT_242: [242, "ศาลเยาวชนและครอบครัวจังหวัดแพร่"],
  COURT_243: [243, "ศาลเยาวชนและครอบครัวจังหวัดมหาสารคาม"],
  COURT_244: [244, "ศาลเยาวชนและครอบครัวจังหวัดแม่ฮ่องสอน"],
  COURT_245: [245, "ศาลเยาวชนและครอบครัวจังหวัดยโสธร"],
  COURT_246: [246, "ศาลเยาวชนและครอบครัวจังหวัดยะลา"],
  COURT_247: [247, "ศาลเยาวชนและครอบครัวจังหวัดระนอง"],
  COURT_248: [248, "ศาลเยาวชนและครอบครัวจังหวัดลพบุรี"],
  COURT_249: [249, "ศาลเยาวชนและครอบครัวจังหวัดเลย"],
  COURT_250: [250, "ศาลเยาวชนและครอบครัวจังหวัดสกลนคร"],
  COURT_251: [251, "ศาลเยาวชนและครอบครัวจังหวัดสมุทรสงคราม"],
  COURT_252: [252, "ศาลเยาวชนและครอบครัวจังหวัดสระแก้ว"],
  COURT_253: [253, "ศาลเยาวชนและครอบครัวจังหวัดสุรินทร์"],
  COURT_254: [254, "ศาลเยาวชนและครอบครัวจังหวัดหนองคาย"],
  COURT_255: [255, "ศาลเยาวชนและครอบครัวจังหวัดหนองบัวลำภู"],
  COURT_256: [256, "ศาลเยาวชนและครอบครัวจังหวัดอุตรดิตถ์"],
  COURT_257: [257, "ศาลเยาวชนและครอบครัวจังหวัดอุทัยธานี"],
  COURT_259: [259, "ศาลแรงงานกลาง(สาขานนทบุรี)"],
  COURT_260: [260, "ศาลแรงงานกลาง(สาขามีนทบุรี)"],
  COURT_261: [261, "ศาลแรงงานกลาง(สาขาสมุทรปราการ)"],
  COURT_262: [262, "ศาลแรงงานกลาง(สาขาสมุทรสาคร)"],
  COURT_263: [263, "ศาลแรงงานภาค 1"],
  COURT_264: [264, "ศาลแรงงานภาค 2"],
  COURT_265: [265, "ศาลแรงงานภาค 2 (สาขาระยอง)"],
  COURT_266: [266, "ศาลแรงงานภาค 3"],
  COURT_267: [267, "ศาลแรงงานภาค 4"],
  COURT_268: [268, "ศาลแรงงานภาค 5"],
  COURT_269: [269, "ศาลแรงงานภาค 6"],
  COURT_270: [270, "ศาลแรงงานภาค 7"],
  COURT_271: [271, "ศาลแรงงานภาค 8"],
  COURT_272: [272, "ศาลแรงงานภาค 9"],
  COURT_274: [274, "ศาลแขวงพยัคฆภูมิพิสัย"],
  COURT_275: [275, "ศาลจังหวัดชุมแพ"],
  COURT_276: [276, "ศาลอาญาคดีทุจริตและประพฤติมิชอบกลาง"],
  COURT_285: [285, "ศาลแขวงนครไทย"],
  COURT_287: [287, "ศาลอุทธรณ์คดีชำนาญพิเศษ"],
  COURT_288: [288, "ศาลเยาวชนและครอบครัวจังหวัดบึงกาฬ"],
  COURT_290: [290, "ศาลอาญาคดีทุจริตและประพฤติมิชอบภาค 1"],
  COURT_291: [291, "ศาลอาญาคดีทุจริตและประพฤติมิชอบภาค 2"],
  COURT_292: [292, "ศาลอาญาคดีทุจริตและประพฤติมิชอบภาค 3"],
  COURT_293: [293, "ศาลอาญาคดีทุจริตและประพฤติมิชอบภาค 4"],
  COURT_294: [294, "ศาลอาญาคดีทุจริตและประพฤติมิชอบภาค 5"],
  COURT_295: [295, "ศาลอาญาคดีทุจริตและประพฤติมิชอบภาค 6"],
  COURT_296: [296, "ศาลอาญาคดีทุจริตและประพฤติมิชอบภาค 7"],
  COURT_297: [297, "ศาลอาญาคดีทุจริตและประพฤติมิชอบภาค 8"],
  COURT_298: [298, "ศาลอาญาคดีทุจริตและประพฤติมิชอบภาค 9"],
  COURT_299: [299, "ศาลจังหวัดเชียงคำ"],
  COURT_300: [300, "ศาลแขวงภูเก็ต"],
  COURT_303: [303, "ศาลแขวงระยอง"],
  COURT_304: [304, "ศาลแขวงเชียงราย"],
  COURT_305: [305, "ศาลแขวงบางบอน"],
  COURT_306: [306, "ศาลแพ่งตลิ่งชัน"],
  COURT_310: [310, "ศาลอาญามีนบุรี"],
  COURT_311: [311, "ศาลอาญาพระโขนง"],
  COURT_312: [312, "ศาลอาญาตลิ่งชัน"],
  COURT_313: [313, "ศาลแพ่งพระโขนง"],
  COURT_314: [314, "ศาลแพ่งมีนบุรี"],
  COURT_315: [315, "ศาลแขวงเชียงดาว"],
  COURT_316: [316, "ศาลจังหวัดมหาสารคาม (สาขาพยัคฆภูมิพิสัย)"],
  COURT_317: [317, "ศาลจังหวัดพิษณุโลก (สาขานครไทย)"],
  COURT_318: [318, "ศาลจังหวัดเชียงราย (สาขาเวียงป่าเป้า)"],
  COURT_319: [319, "ศาลแขวงกระบี่"],
  COURT_320: [320, "ศาลแขวงตรัง"],
  COURT_321: [321, "ศาลเยาวชนและครอบครัวจังหวัดยะลา(เบตง)"],
  COURT_322: [322, "ศาลจังหวัดพระประแดง"],
  COURT_323: [323, "ศาลแขวงสุวรรณภูมิ"],
  COURT_324: [324, "ศาลจังหวัดร้อยเอ็ด (สาขาสุวรรณภูมิ)"],
};

export const getSelectOptions = (list) =>
  Object.entries(list).map(([key, [value, label]]) => ({
    value,
    label,
  }));

export const allCourtOptions = getSelectOptions(courtList);
